export default {
  SET_COVER_PIC_PROGRESS (state, payload) {
    state.coverPicProgress = payload
  },
  SET_MY_MEETUPS (state, payload) {
    state.myMeetups = payload
  },
  SET_MEETUPS (state, payload) {
    state.meetups = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/meetups/mutations.js